import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { fetchEstates } from 'shared/stores/store';
import MapContent from './EstateMapContent';
import EstatesGrid from '../EstatesGrid';

const GOOGLE_MAPS_API_KEY = 'AIzaSyDHeASGVySF_J2T1ctEiAkVUdv9oBCgKjI';

export default function EstatesMapPage() {
    const dispatch = useDispatch();
    const estates = useSelector((state) => state.estates.list);
    const loading = useSelector((state) => state.estates.loading);
    const error = useSelector((state) => state.estates.error);
    const [selectedEstate, setSelectedEstate] = useState(null);
    const [filteredEstates, setFilteredEstates] = useState(null);

    useEffect(() => {
        dispatch(fetchEstates());
    }, [dispatch]);

    const handleMarkerClick = useCallback((estate) => {
        setSelectedEstate(estate);
        // Scroll to the estate in the list
        const element = document.getElementById('estates-results');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const handlePolygonFilter = useCallback((estatesInPolygon) => {
        setFilteredEstates(estatesInPolygon);
    }, []);

    const handleClearPolygon = useCallback(() => {
        setFilteredEstates(null);
    }, []);

    if (loading) return <div className="text-center py-10">Loading map...</div>;
    if (error) return <div className="text-center py-10 text-red-500">Error: {error}</div>;

    const displayedEstates = filteredEstates || estates;

    return (
        <div className="max-w-[1920px] mx-auto pt-[69px]">
            <div style={{width: '100%', height: '60vh'}}>
                <APIProvider
                    apiKey={GOOGLE_MAPS_API_KEY}
                    libraries={['places', 'geometry']}
                >
                    <Map
                        mapId="8f541c90bb5b58e2"
                        defaultCenter={{lat: 40.0452, lng: -4.0815}}
                        defaultZoom={6}
                        gestureHandling="greedy"
                        disableDefaultUI={false}
                        zoomControl={true}
                        streetViewControl={false}
                        scaleControl={true}
                        options={{
                            mapTypeControl: false,
                            fullscreenControl: false,
                            mapTypeControlOptions: {
                                position: window.google?.maps?.ControlPosition?.TOP_RIGHT
                            }
                        }}
                    >
                        <MapContent
                            estates={estates}
                            selectedEstate={selectedEstate}
                            onMarkerClick={handleMarkerClick}
                            onPolygonFilter={handlePolygonFilter}
                            onClearPolygon={handleClearPolygon}
                        />
                    </Map>
                </APIProvider>
            </div>

            {/* List view below the map using EstatesGrid */}
            <div className="bg-white" id="estates-results">
                {filteredEstates && (
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-12 hidden">
                        <div className="p-4 bg-sky-100 rounded-lg">
                            <p className="text-sky-800">
                                Viser {filteredEstates.length} ejendomme i det valgte område
                            </p>
                        </div>
                    </div>
                )}

                <EstatesGrid
                    estates={displayedEstates}
                    showFilters={true}
                    showSort={true}
                    className="pb-24"
                    selectedEstate={selectedEstate}
                />
            </div>
        </div>
    );
}